/**
 * TPS Design System — Runtime JS
 * Scroll reveal + animated counters.
 * Lightweight (~60 lines), no dependencies.
 */
(function () {
  'use strict';

  /* ── Scroll Reveal ────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('[data-tps-reveal]:not(.tps-revealed)');
    if (!els.length) return;

    // Respect reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('tps-revealed'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tps-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Animated Counters ────────────────────────── */
  function initCounters() {
    var counters = document.querySelectorAll('[data-tps-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);

          var target = parseInt(el.getAttribute('data-tps-counter'), 10);
          var suffix = el.getAttribute('data-tps-counter-suffix') || '';
          var duration = 1200;
          var start = performance.now();

          function tick(now) {
            var progress = Math.min((now - start) / duration, 1);
            // Ease-out cubic
            var eased = 1 - Math.pow(1 - progress, 3);
            el.textContent = Math.round(target * eased) + suffix;
            if (progress < 1) requestAnimationFrame(tick);
          }

          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.3 }
    );

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ── Init ──────────────────────────────────────── */
  function init() {
    initReveal();
    initCounters();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify theme editor loads/reloads sections
  document.addEventListener('shopify:section:load', init);
})();
